import { DRAGGABLE_WINDOWS_ACTIONS } from '../../constants.js';

export function insertWindow(dragComponent, closeComponentIfOpen) {
  return {
    type: DRAGGABLE_WINDOWS_ACTIONS.INSERT_WINDOW,
    closeIfOpen: closeComponentIfOpen,
    draggableComponent: dragComponent,
  };
}

export function removeWindow(iDdragComponents) {
  let drag = [];

  if (typeof iDdragComponents !== 'undefined' && iDdragComponents !== null) {
    if (typeof iDdragComponents === 'string') {
      drag = [iDdragComponents];
    } else {
      drag = iDdragComponents;
    }
  }
  return {
    type: DRAGGABLE_WINDOWS_ACTIONS.REMOVE_WINDOW,
    idComponents: drag
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/A_draggable_windows_controller.js